import type { ClinicSession } from "@auth/clinicAuthClient";
import { createContext, useContext } from "react";

export interface AuthContextValue {
  session: ClinicSession | null;
  isAuthed: boolean;
  login: (subdomain: string, password: string) => Promise<void>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
